<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-war-of-the-galaxy">
<br/><br/><br/><br/><br/><h1>The War of the Galaxy</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?60d8971f